export default {
    'textbook': {
        'text': `<div class="content-caption-box">
				<h3 class="content-caption">The Minto Pyramid Principle® Textbook</h3>
			</div>
			<p class="content-text"><dfn>The Minto Pyramid Principle:  Logic in Writing, Thinking and Problem Solving</dfn> (2010 edition) explains the technique
				for helping you work out and organize your thinking before you attempt to communicate it. In 12 chapters and 3 appendices,
				it explains how the pyramid works, how to pull your thinking together to create a pyramid structure, and how to look
				critically at the ideas you assemble so as to glean actual insights from them vs simply presenting them as lists of “reasons”
				or “issues”.</p>
			<p class="content-text">The book also has a section on problem definition and problem analysis, useful in situations where you are writing to
				present the solution to a problem, or explaining how you will go about solving one</p>
			<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate your ideas and to organize
				them at the same time. Thus avoiding the need to write countless drafts before you can figure out your message.</p>
			<p class="content-text">The book has become the standard text used by all of the major consulting firms worldwide, many organizations, and some
				government offices. It is in fact the book that changed the consulting industry, and the phrase “Take this and make it
				Minto” is common in many companies. It has been translated into. . .Chinese, French, German, Japanese, Korean, Portuguese,
				and Viet Namese.</p>
			<p class="content-text">The cost of the book is $135 plus postage from New York. Bona fide students wishing to buy the book should e-mail Barbara
				Minto directly at barminto@aol.com to apply for a student discount.</p>

			<p class="proposal-heading content-text"><b>Note:</b> This book supersedes <dfn>The Pyramid Principle: Logic in Writing and Thinking</dfn> [1987, reissued in London
				2002], which consists of 9 chapters and 1 appendix.</p>`,
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/site/textbook/i18n/en.js